import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button } from '@mui/material';
import ShippingTimelineModal from 'common/modules/ShippingTimelineModal';

const ShipmentHistoryButton = ({ orderId }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button size='small' variant='outlined' color='primary' onClick={() => setOpen(true)}>
        View Shipment History
      </Button>
      <ShippingTimelineModal open={open} onClose={() => setOpen(false)} orderId={orderId} />
    </>
  );
};

ShipmentHistoryButton.propTypes = {
  orderId: PropTypes.string.isRequired,
};

export default ShipmentHistoryButton;
